/* eslint-disable no-unused-expressions */
/* eslint-disable func-names */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import Carousel from 'react-bootstrap/Carousel';
import debounce from 'lodash.debounce';

// import { Carousel } from '3d-react-carousal';

import Modal from '../Modal/Modal';
import {
    WhiteDiamond,
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    DiamondSm,
    Diamond,
} from '../../Constants/assets';
import fetchConfig from '../../Constants/fetch';

const CenterAll = styled.div`
    width: 85%;
`;

const HeaderContainer = styled.div`
    height: 10%;
    display: flex;
    justify-content: space-between;
`;
const TopScreenNumContainer = styled.div`
    width: 13%;
    place-self: center;
    text-align-last: center;
`;
const TopScreenBorder = styled.div`
    opacity: 0.5;
    border: 1px solid ${props => props.theme.colors.white};
    box-sizing: border-box;
    border-radius: 8px;
`;
const TopScreenNumber = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 22px;
    color: ${props => props.theme.colors.white};
    opacity: 0.5;
`;

const TaskContainer = styled.h1`
    font-style: normal;
    font-weight: bold;
    font-size: 1.3rem;
    line-height: 28px;
    height: 100%;
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.white};
    width: 82%;
`;
const ParagraphContainer = styled.div`
    width: 100%;
    height: 31%;
    line-height: 21.8px;
    margin-bottom: 10px;
`;
const DelayParagraphContainer = styled.div`
    width: 100%;
    height: 20.5%;
`;

const PriceNScoreContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 33%;
    margin-bottom: 15px;
`;
const LeftCon = styled.div`
    height: 100%;
    font-size: 16px;
    margin-right: 65px;
`;
const RightCon = styled.div`
    width: 40%;
    justify-items: stretch;
    height: 100%;
`;
const SecondLineContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 90%;
    height: 33%;
    margin-bottom: 20px;
`;
const EarnedValueContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`;
const BtnDiv = styled.div`
    height: 60px;
    display: flex;
    align-items: flex-end;
`;
const BoxContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
`;
const NumNextImg = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    padding-right: 10px;
`;
// Error Styling
const ErrorContainer = styled.div`
    // display: none;
    height: 50%;
    div {
        padding-bottom: 6px;
    }
`;
const TaskPopUp = ({
    taskInfo,
    reachedMaximumAmountOfUnplannedTasks,
    earnedValue,
    price,
    steps,
    btnOptionOne,
    btnOptionTwo,
    taskName,
    whiteNum,
    redNum,
    greenNum,
    topScreenNum,
    DelayTwoOptions,
    handleCard,
    performCard,
    playerStatus,
    toggleResources,
    additionalBudget,
    commentAdditionalBudget,
    cardEffect,
    card,
    handleUnplannedCards,
    unplannedCards,
    explanationCard,
    removeUnplannedCards,
    handleGetNewCard,
    setCardState,
    cardState,
    SoundPlay,
    soundForFlipAndCards,
    errorSound,
    additionalBudgetGlobalFunction,
    isGamePausedRef,
    cardsLiveViewRefGlobal,
    cardsLiveView,
    setCardsLiveView,
    toggleProject,
    openStage,
    gameId,
    userId,
    tasksButOrTasksNotSaved,
    setTasksButOrTasksNotSaved,
    setSelectedCardIs,
    setIsChoosingFromDelayedCard,
    setOneLessStep,
    oneLessStep,
}) => {
    // Stylings
    const InnerContainer = styled.div`
    ${({ taskNameColor = taskName }) => handleColorType(taskNameColor)};
    width: 364px;
    height: 650px;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    position: absolute;
    
    /* Media query for screens with a height less than 730px */
    ${css`
        @media (max-height: 730px) {
        /* CSS styles for screens with a height less than 730px */
        height: 99%;
        }
    `}
    `;

    const Or = styled.div`
        width: 100%;
        font-style: normal;
        font-weight: normal;
        font-size: 42px;
        line-height: 49px;
        text-align: center;
        color: ${props => props.theme.colors.white};
        height: 19%;
    `;
    const Paragraph = styled.p`
        font-size: 16px;
        line-height: normal;
        color: ${props => props.theme.colors.white};
    `;

    const LeftConEarnedValue = styled.div`
        ${({ taskNameColor = taskName }) => displayNone(taskNameColor)};
        height:100%;
    `;

    const SNPText = styled.div`
        font-style: normal;
        font-weight: bold;
        font-size: 17px;
        line-height: 16px;
        color: ${props => props.theme.colors.white};
        height: 50%;
    `;
    const WhiteDiamondContainer = styled.div``;
    const SNPNumber = styled.div`
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 25px;
        color: ${props => props.theme.colors.white};
        display: flex;
        width: min-content;
    `;
    const BtnCon = styled.div`
        display: flex;
        flex-direction: column;
        justify-items: flex-end;
        height: 50%;
    `;
    const Btn = styled.button`
        width: 100%;
        // height: 80%;
        min-height:80%;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid ${props => props.theme.colors.white};
        box-sizing: border-box;
        border-radius: 8px;
        cursor: pointer;
    `;
    const BtnText = styled.div`
        font-style: normal;
        font-weight: 500;
        font-size: 19px;
        line-height: 22px;
        text-align: center;
        color: ${props => props.theme.colors.white};
        display: flex;
        align-itmes: center;
        justify-content: center;
    `;

    const ErrorHeadLine = styled.div`
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        ${props =>
            props.taskName == 'Constraint'
                ? css`
                      color: ${componentProps => componentProps.theme.colors.orange};
                  `
                : css`
                      color: ${componentProps => componentProps.theme.colors.white};
                  `};
        color: ${taskName == 'unplanned-task' ? '#FC9D2C' : ''};
        width: 100%;
    `;
    const OptionContainer = styled.div`
        font-weight: normal;
        font-size: 16px;
        line-height: 14px;
        text-decoration-line: underline;
        color: ${props => props.theme.colors.white};
        margin-top: 1%;
    `;
    const BigDiamond = styled(WhiteDiamond)`
        width: 22px;
        height: 22px;
    `;

    const handleColorType = taskNameColor => {
        switch (taskNameColor) {
            case 'unplanned-task':
                return 'background: #005857';
            case 'Risk':
                return 'background: #a90821;';
            case 'Constraint':
                return 'background: #fc9d2c;';
            case 'Delay':
                return 'background: #007a9e;';
            default:
        }
    };
    const displayNone = taskNameColor => {
        if (taskNameColor == 'Constraint' || taskNameColor == 'Risk') {
            return 'display: none;';
        }
    };

    const canExecuteTasks = () => {
        if (
            ((playerStatus.budget >= Math.abs(price) || price > 0)) &&
            (whiteNum > 0 || playerStatus.resources.regular >= Math.abs(whiteNum)) &&
            (redNum > 0 || playerStatus.resources.executive >= Math.abs(redNum)) &&
            (greenNum > 0 || playerStatus.resources.expensive >= Math.abs(greenNum))
        ) {
            return true
        }
    }

    const chekWrongConstrains = () => {
        const listOfWrongConstraint = [26, 27, 28, 29, 30, 31, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 46, 47, 48, 50, 54, 55, 56, 58, 59, 61, 62, 63, 64, 65, 66];
        if (listOfWrongConstraint.includes(topScreenNum)) {
            return true;
        }
    };
    const noSeconButtonNeed = () => {
        const listCardsWithoutSeconButton = [58, 59, 50, 61];
        if (listCardsWithoutSeconButton.includes(topScreenNum)) {
            return true;
        }
    };
    const chekTakeDelayCardStatus = () => {
        let result = false;
        const listOfCardsThatTakeDelay = [
            1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
            27, 28, 29, 30, 31, 34, 35, 36, 37, 38, 39, 40, 41, 42, 44, 46, 47, 48, 54, 55, 56, 60, 62, 63, 64, 66,
        ];
        if (listOfCardsThatTakeDelay.includes(topScreenNum)) {
            result = true;
        }
        return result;
    };

    const commentDelayFromUnplannedTask = async (parentTaskRowId = -1) => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'Task executed after being delayed',
            taskRowId: parentTaskRowId,
        };
        if (unplannedCards.length > 0) {
            axios
                .get(
                    `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(data.commentContent)}&taskRowId=${data.taskRowId}`,
                    data,
                )
                .catch(error => console.log(error));
        }
    };
    // TurnNumber should be changed to parentTaskRowId
    const commentAskForAdditionalBudget = async (parentTaskRowId) => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            taskRowId: parentTaskRowId,
            commentContent: `${card.costMoney}$ Additional budget received`
        };
        axios
            .get(
                `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(data.commentContent)}&taskRowId=${data.taskRowId}`,
                data,
            )
            .catch(error => console.log(error));
    };

    const translationCodeToAction = [
        0, 120, 180, 0, 0, 100,
        150, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0,
        0, 0, 60, 0, 0, 0,
        0, 0, 60
    ];


    if (translationCodeToAction[topScreenNum] === undefined) {
        translationCodeToAction[topScreenNum] = 60;  // 60;
    }

    // eslint-disable-next-line prefer-const
    let [temp, setTemp] = useState(translationCodeToAction[topScreenNum]);
    const [delayButtonOption, setDelayButtonOption] = useState(translationCodeToAction[topScreenNum]);
    const constantDelayButtonOption = translationCodeToAction[topScreenNum];
    const { t, i18n } = useTranslation();
    const fontSize62 = i18n.language === 'es' ? '19px' : '17px';

    // translationCodeToAction[65] = 5;  // HOTFIX, the Wait X seconds card goes to index 65 which doesnt exist, this needs to be patched later
    //                                   // @TODO: Make it less Hard Coded. 

    const [isClicked, setIsClicked] = useState(false);

    const commentTrapTaskPerformed = async (parentTaskRowId) => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            taskNumber: topScreenNum,
            commentContent: 'Expensive task with low value',
            taskRowId: parentTaskRowId,
        };

        if (topScreenNum == 14 || topScreenNum == 15 || topScreenNum == 16) {
            const result = await axios.get(`${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                data.commentContent,
            )}&taskRowId=${data.taskRowId}`, data);
        }
    };
    const [commentLaterAdditionalBudget, setcommentLaterAdditionalBudget] = useState(0)
    const [disbleButton, setDisbleButton] = useState(false);
    const [cursorType, setCursorType] = useState('pointer');

    const [delayFromUnplannedTask, setDelayFromUnplannedTask] = useState(false);

    const [additionalBudgetValid, setAdditionalBudgetValid] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [modalContent, setModalContent] = useState(
        'modals.additional_budget.info_text',
    );
    const [modalTitle, setModalTitle] = useState('modals.additional_budget.info_text');
    const [additionalBudgetPopUp, setAdditionalBudgetPopUp] = useState(false);
    const ModalContainer = styled.div`
        position: absolute;
        z-index: 11;
    `;
    const [removeOnlyOneTime, setRemoveOnlyOneTime] = useState(cardState);
    const addBackCard = () => {
        setCardState(false);
        handleUnplannedCards(card, true);
    }
    const [stage, setStage] = useState(1);
    const [carouselIndex, setCarouselIndex] = useState(0);

    const handleCarouselMovement = selectedIndex => {
        setSelectedCardIs(unplannedCards[selectedIndex - 1]?.id)
        setCarouselIndex(selectedIndex);
    };
    const insertVariablesToTranslation = (translationText, isNotDynamic) => {
        console.log("isdynamic", translationText, isNotDynamic);
        if (translationText.includes("$T") && typeof constantDelayButtonOption !== 'undefined' && isNotDynamic) {
            translationText = translationText.replace("$T", Math.abs(constantDelayButtonOption));
        }
        if (translationText.includes("$C") && typeof constantDelayButtonOption !== 'undefined' && isNotDynamic) {
            translationText = translationText.replace("$C", Math.abs(constantDelayButtonOption));
        }

        if (translationText.includes("$T") && typeof delayButtonOption !== 'undefined') {
            translationText = translationText.replace("$T", Math.abs(delayButtonOption));
        }
        if (translationText.includes("$P") && typeof price !== 'undefined') {
            translationText = translationText.replace("$P", `$${Math.abs(price)}`);
        }
        if (translationText.includes("$M") && typeof steps !== 'undefined') {
            translationText = translationText.replace("$M", Math.abs(steps));
        }
        if (translationText.includes("$R") && typeof whiteNum !== 'undefined') {
            translationText = translationText.replace("$R", Math.abs(whiteNum));
        }
        if (translationText.includes("$S") && typeof redNum !== 'undefined') {
            translationText = translationText.replace("$S", Math.abs(redNum));
        }
        if (translationText.includes("$E") && typeof greenNum !== 'undefined') {
            translationText = translationText.replace("$E", Math.abs(greenNum));
        }
        if (translationText.includes("$C") && typeof delayButtonOption !== 'undefined') {
            translationText = translationText.replace("$C", Math.abs(delayButtonOption));
        }
        if (translationText.includes("$D") && typeof DelayTwoOptions.optionTwo !== 'undefined') {
            translationText = translationText.replace("$D", Math.abs(DelayTwoOptions.optionTwo));
        }
        return translationText;
    }

    const insertVariablesToDelayTranslation = (translationText) => {
        const [beforeD, afterD] = translationText.split("$D");
        return (
            <span>
                {beforeD}{DelayTwoOptions.optionTwo}<BigDiamond /> {afterD}
            </span>
        );
    }

    // sometime the delay options button is undefined which can lead to it being displayed as NaN when preforming 
    if (delayButtonOption === undefined || temp === undefined) {
        setDelayButtonOption(60);  // default value
        setTemp(60);  // default value
    }
    if (taskName == 'Constraint' || taskName == 'Risk') {
        return (
            <>
                <ModalContainer>
                    <Modal
                        style={{}}
                        modalTitle={modalTitle}
                        modalText={modalContent}
                        modalButton="modals.additional_budget.button1"
                        additionalBudgetValid={additionalBudgetValid}
                        modalButtonContinue="modals.additional_budget.button2"
                        toggleShow={() => setModalShow(false)}
                        show={modalShow}
                        additionalBudget={additionalBudget}
                        commentAdditionalBudget={commentAdditionalBudget}
                        setAdditionalBudgetPopUp={setAdditionalBudgetPopUp}
                    />
                </ModalContainer>
                <InnerContainer taskName={taskName} style={{
                    zIndex: '26'
                }}>
                    <CenterAll>
                        <HeaderContainer>
                            <TaskContainer>
                                {taskName != t(`global_variables.actions.unplanned_task`) ? taskName : t('global_variables.task')}
                            </TaskContainer>
                            <TopScreenNumContainer>
                                <TopScreenBorder>
                                    <TopScreenNumber>{topScreenNum}</TopScreenNumber>
                                </TopScreenBorder>
                            </TopScreenNumContainer>
                        </HeaderContainer>
                        <ParagraphContainer>
                            <Paragraph>
                                {t(`cards.card.${topScreenNum}.card_title`, { topScreenNum })}
                            </Paragraph>
                            {cardEffect != '' && (
                                <Paragraph>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.info_text`, { topScreenNum }))}</Paragraph>
                            )}
                        </ParagraphContainer>
                        <PriceNScoreContainer>
                            <SecondLineContainer>
                                <LeftCon>
                                    {price > 0 && <SNPText>{t(`global_variables.get_budget_link`)}</SNPText>}
                                    {price <= 0 && <SNPText> {t(`global_variables.cost`)}</SNPText>}
                                    <SNPNumber> ${Math.abs(price)}</SNPNumber>
                                </LeftCon>
                                <RightCon>
                                    {(whiteNum > 0 || redNum > 0 || greenNum > 0) && (
                                        <SNPText
                                        > {t(`global_variables.get_resources_link`)}</SNPText>
                                    )}
                                    {(whiteNum <= 0 && redNum <= 0 && greenNum <= 0) && (
                                        <SNPText> {t(`global_variables.resources.resources`)}</SNPText>
                                    )}
                                    <SNPNumber>
                                        <BoxContainer>
                                            <WhiteSource />
                                            <NumNextImg>{Math.abs(whiteNum)}</NumNextImg>
                                        </BoxContainer>
                                        <BoxContainer>
                                            <RedSource />
                                            <NumNextImg>{Math.abs(redNum)}</NumNextImg>
                                        </BoxContainer>
                                        <BoxContainer>
                                            <GreenSource />
                                            <NumNextImg>{Math.abs(greenNum)}</NumNextImg>
                                        </BoxContainer>
                                    </SNPNumber>
                                </RightCon>
                            </SecondLineContainer>
                            <SecondLineContainer>
                                <LeftConEarnedValue>
                                    <SNPText style={{ marginTop: '5px' }}> {t(`global_variables.value`)}</SNPText>
                                    <EarnedValueContainer>
                                        <SNPNumber> {Math.abs(earnedValue)}</SNPNumber>
                                        <WhiteDiamondContainer>
                                            <WhiteDiamond />
                                        </WhiteDiamondContainer>
                                    </EarnedValueContainer>
                                </LeftConEarnedValue>
                                <LeftCon>
                                    {steps > 0 &&
                                        Math.abs(steps) !== 100 &&
                                        Math.abs(steps) !== 1000 && (
                                            <>
                                                <SNPText>{t(`global_variables.steps`)}</SNPText>
                                                {(oneLessStep && Math.abs(steps) > 0) ?
                                                    <SNPNumber>
                                                        <div style={{ textDecoration: (oneLessStep && steps > 0) ? 'line-through' : '' }}>
                                                            {Math.abs(steps)}
                                                        </div>
                                                        <div style={{ display: (oneLessStep && steps > 0) ? 'block' : 'none', marginLeft: '4px' }}>
                                                            {Math.abs(steps) - 1}
                                                        </div>
                                                    </SNPNumber>
                                                    : <SNPNumber>
                                                        {Math.abs(steps)}
                                                    </SNPNumber>
                                                }                                            </>
                                        )}
                                    {steps <= 0 && (
                                        <>
                                            <SNPText>{t(`global_variables.steps`)}</SNPText>
                                            <SNPNumber>{Math.trunc(steps)}</SNPNumber>
                                        </>
                                    )}
                                </LeftCon>
                            </SecondLineContainer>
                            {!canExecuteTasks() &&
                                (price < 0 || whiteNum < 0 || redNum < 0 || greenNum < 0) && (
                                    <ErrorContainer>
                                        <ErrorHeadLine>
                                            {t(`cards.card.not_enough_resources`)}
                                        </ErrorHeadLine>
                                        <OptionContainer
                                            style={{ cursor: 'pointer', width: 'max-content' }}
                                            onClick={(e) => {
                                                e.persist();
                                                toggleResources('Buy resources')
                                            }}
                                        >
                                            {t(`global_variables.get_resources_link`)}
                                        </OptionContainer>
                                        <OptionContainer
                                            style={{ cursor: 'pointer', width: 'max-content' }}
                                            onClick={(e) => {
                                                e.persist();
                                                additionalBudgetGlobalFunction(
                                                    'modals.additional_budget.info_title',
                                                    'modals.additional_budget.info_text',
                                                    'modals.additional_budget.button1',
                                                    'modals.additional_budget.button1'
                                                )
                                            }}
                                        >
                                            {t(`global_variables.additional_budget_link`)}
                                        </OptionContainer>
                                    </ErrorContainer>
                                )
                            }
                        </PriceNScoreContainer>

                        <BtnCon>
                            {canExecuteTasks() && !chekWrongConstrains() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        {taskName == 'Constraint' && (
                                            <BtnText>{t(`cards.card.constraint_button1`)}</BtnText>
                                        )}
                                        {taskName == 'Risk' && <BtnText>{t(`cards.card.risk_button1`)}</BtnText>}
                                        {taskName == 'unplanned-task' && (
                                            <BtnText>{t(`cards.card.unplanned_button1`)}</BtnText>
                                        )}
                                    </Btn>
                                </BtnDiv>
                            )}
                            {canExecuteTasks() && !chekWrongConstrains() && !chekTakeDelayCardStatus() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        {taskName == 'Constraint' && (
                                            <BtnText>{t(`cards.card.unable_execute_constraint`)}</BtnText>
                                        )}
                                        {taskName == 'Risk' && <BtnText>{t(`cards.card.unable_execute_risk`)}</BtnText>}
                                    </Btn>
                                </BtnDiv>
                            )}
                            {!canExecuteTasks() &&
                                !chekWrongConstrains() &&
                                (price < 0 || whiteNum < 0 || redNum < 0 || greenNum < 0) && (
                                    <BtnDiv>
                                        <Btn
                                            style={{
                                                opacity: '0.5',
                                                cursor: 'context-menu',
                                            }}
                                        >
                                            {taskName == 'Constraint' && (
                                                <BtnText>{t(`cards.card.constraint_button1`)}</BtnText>
                                            )}
                                            {taskName == 'Risk' && <BtnText>{t(`cards.card.risk_button1`)}</BtnText>}
                                            {taskName == 'unplanned-task' && (
                                                <BtnText>{t(`cards.card.unplanned_button1`)}</BtnText>
                                            )}
                                        </Btn>
                                    </BtnDiv>
                                )}
                            {((topScreenNum === 65 || topScreenNum === 26) && taskName === 'Constraint')   // DEFUQ? the array translationCodeToAction is only 20ish in length how do we get here?
                                && (                                                                           // I Dont want to delete this line in case it breaks anything but beware....
                                    <>
                                        <BtnDiv>
                                            <Btn
                                                disabled={disbleButton}
                                                onClick={debounce((ev) => {
                                                    ev.persist();
                                                    if (disbleButton)
                                                        return false;
                                                    try {
                                                        clearInterval(x); // prevent interval running twice leading to negative seconds
                                                    } catch (e) { ; }
                                                    setDisbleButton(true)
                                                    setCursorType('context-menu')
                                                    const x = setInterval(function () {
                                                        if (isGamePausedRef.current) return;
                                                        SoundPlay(errorSound);
                                                        temp--;
                                                        setDelayButtonOption(prevDelayButtonOption => prevDelayButtonOption - 1);
                                                        if (!x) {
                                                            performCard(topScreenNum, taskName, 1);
                                                            clearInterval(x);
                                                        }
                                                        if (temp < 1 || delayButtonOption < 0) {
                                                            performCard(topScreenNum, taskName, 1);
                                                            clearInterval(x);
                                                        }
                                                    }, 1000);
                                                }, 50)}
                                            >
                                                <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                            </Btn>
                                        </BtnDiv>
                                    </>
                                )}
                            {topScreenNum === 27 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 27 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 28 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => { // suggestion - onClick={ canExecuteTasks() ? (e)=>... : null}
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 28 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 29 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 29 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 30 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName)
                                        }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 30 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn
                                        style={{ opacity: '0.5', cursor: 'context-menu' }}
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName)
                                        }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 31 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 31 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 34 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText style={{ fontSize: '17px' }}>
                                            {insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 34 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText style={{ fontSize: '17px' }}>
                                            {insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 35 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 35 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 36 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 36 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 37 || topScreenNum === 40) && canExecuteTasks()) && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 37 || topScreenNum === 40) && !canExecuteTasks()) && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 38 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 38 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 39 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 39 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 41 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 41 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 42 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 42 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 43 || topScreenNum === 50) && canExecuteTasks()) && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName, null) //  commentAskForAdditionalBudget deleted for hamutal request.
                                    }}>
                                        <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 43 || topScreenNum === 50) && !canExecuteTasks()) && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 46 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 46 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 47 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 47 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 48 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 48 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 54 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName);
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 54 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 55 || topScreenNum == 44) && canExecuteTasks()) && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName);
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 55 || topScreenNum == 44) && !canExecuteTasks()) && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 56 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 56 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {((topScreenNum === 58 ||
                                topScreenNum === 61) && canExecuteTasks()) && (
                                    <BtnDiv>
                                        <Btn onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName);
                                        }}>
                                            <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                            {((topScreenNum === 58 ||
                                topScreenNum === 61) && !canExecuteTasks()) && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                            {topScreenNum === 59 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 59 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 62 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText style={{ fontSize: fontSize62 }}>
                                            {insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 62 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText style={{ fontSize: fontSize62 }}>
                                            {insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 63 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 63 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{insertVariablesToTranslation(t(`cards.card.${topScreenNum}.button1`, topScreenNum))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 66 && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName)
                                    }}>
                                        <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {topScreenNum === 66 && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>{t(`cards.card.${topScreenNum}.button1`, topScreenNum)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {chekTakeDelayCardStatus() && !canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        handleCard('Delay');
                                        SoundPlay(soundForFlipAndCards);
                                    }}>
                                        <BtnText>{t(`cards.card.unplanned_button2`)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {chekTakeDelayCardStatus() && canExecuteTasks() && (
                                <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'auto' }}>
                                        <BtnText>{t(`cards.card.unplanned_button2`)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {taskName == 'Risk' &&
                                !chekTakeDelayCardStatus() &&
                                !noSeconButtonNeed() &&
                                !canExecuteTasks() && (
                                    <BtnDiv>
                                        <Btn onClick={(e) => {
                                            e.persist();
                                            handleCard('Risk');
                                        }}>
                                            <BtnText>{t(`cards.card.unable_execute_risk`)}</BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                            {taskName == 'Constraint' &&
                                !chekTakeDelayCardStatus() &&
                                !noSeconButtonNeed() &&
                                !canExecuteTasks() && (
                                    <BtnDiv>
                                        <Btn onClick={(e) => {
                                            e.persist();
                                            handleCard('Constraint');
                                        }}>
                                            <BtnText>{t(`cards.card.unable_execute_constraint`)}</BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                        </BtnCon>
                    </CenterAll>
                </InnerContainer>
            </>
        );
    }
    if (taskName == 'Delay') {
        const cardName = card.name.replace('\n\n', ' ').split('OR');
        // const dcardsTextArray = t(`cards.dcards.${topScreenNum}.info_text`).split(t(`cards.dcards.or`));
        console.log("cardName ", cardName[0], card.name)
        return (
            <InnerContainer style={{
                zIndex: '30'
            }}>
                <CenterAll>
                    <HeaderContainer style={{ height: '14%' }}>
                        <TaskContainer>{t(`global_variables.actions.delay`)}</TaskContainer>
                        <TopScreenNumContainer>
                            <TopScreenBorder>
                                <TopScreenNumber>{topScreenNum}</TopScreenNumber>
                            </TopScreenBorder>
                        </TopScreenNumContainer>
                    </HeaderContainer>
                    {
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>{(t(`cards.dcards.global_text`))}</Paragraph>
                            </DelayParagraphContainer>
                        </>
                    }
                    {/* {topScreenNum === 2 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>Wait 180 Seconds</Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 1,000 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )}
                    {topScreenNum === 3 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Go back to the last milestone you passed, or the last gate you passed, or the starting point,
                                </Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 1,000 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )}
                    {topScreenNum === 4 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Go back to the starting point
                                </Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 2,000 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )}
                    {topScreenNum === 5 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Click this button 100 times
                                </Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 500 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )}
                    {topScreenNum === 6 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Click this button 150 times
                                </Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 1,000 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )}
                    {topScreenNum === 7 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Redo the Last Task
                                </Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 1,000 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )}
                    {topScreenNum === 10 && (
                        <>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    From this point on and until the next gate, any positive forward progress will be worth one less step
                                </Paragraph>
                            </DelayParagraphContainer>
                            <Or> OR</Or>
                            <DelayParagraphContainer>
                                <Paragraph style={{ fontSize: '16px' }}>
                                    Deduct 1000 from the value earned to your project
                                </Paragraph>
                            </DelayParagraphContainer>
                        </>
                    )} */}
                    <BtnCon style={{
                        height: '50%',
                        justifyContent: 'space-between', /* מפזר את האלמנטים */
                    }}>

                        {topScreenNum === 1 && (
                            <>
                                <BtnDiv>
                                    <Btn
                                        disabled={disbleButton}
                                        style={{ cursor: cursorType }}
                                        onClick={debounce((ev) => {
                                            ev.persist();
                                            if (disbleButton)
                                                return false;
                                            try {
                                                clearInterval(x); // prevent interval running twice leading to negative seconds
                                            } catch (e) { ; }
                                            setIsClicked(true);
                                            setDisbleButton(true)
                                            setCursorType('context-menu')
                                            const x = setInterval(function () {
                                                if (isGamePausedRef.current) return;
                                                SoundPlay(errorSound);
                                                temp--;
                                                setDelayButtonOption(prevDelayButtonOption => prevDelayButtonOption - 1);
                                                if (!x) {
                                                    performCard(topScreenNum, taskName, 1);
                                                    clearInterval(x);
                                                }
                                                if (temp < 1 || delayButtonOption < 0) {
                                                    performCard(topScreenNum, taskName, 1);
                                                    clearInterval(x);
                                                }
                                            }, 1000);
                                        }, 50)}
                                    >
                                        <BtnText>{insertVariablesToTranslation(t(`cards.dcards.1.button1`))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 500 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 500 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 500 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn
                                        disabled={isClicked}
                                        style={{ cursor: isClicked ? 'context-menu' : 'pointer', opacity: isClicked ? '0.5' : '1' }}
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName, 2)
                                        }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.1.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}
                            </>
                        )}
                        {topScreenNum === 2 && (
                            <>
                                <BtnDiv>
                                    <Btn
                                        disabled={disbleButton}
                                        style={{ cursor: cursorType }}
                                        onClick={debounce((ev) => {
                                            ev.persist();
                                            if (disbleButton)
                                                return false;
                                            try {
                                                clearInterval(x); // prevent interval running twice leading to negative seconds
                                            } catch (e) { ; }
                                            setIsClicked(true);
                                            setDisbleButton(true)
                                            setCursorType('context-menu')
                                            const x = setInterval(function () {
                                                if (isGamePausedRef.current) return;
                                                SoundPlay(errorSound);
                                                temp--;
                                                setDelayButtonOption(prevDelayButtonOption => prevDelayButtonOption - 1);
                                                if (!x) {
                                                    performCard(topScreenNum, taskName, 1);
                                                    clearInterval(x);
                                                }
                                                if (temp < 1 || delayButtonOption < 0) {
                                                    performCard(topScreenNum, taskName, 1);
                                                    clearInterval(x);
                                                }
                                            }, 1000);
                                        }, 50)}
                                    >
                                        <BtnText>{insertVariablesToTranslation(t(`cards.dcards.2.button1`))}</BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 1000 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 1000 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 1000 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn
                                        disabled={isClicked}
                                        style={{ cursor: isClicked ? 'context-menu' : 'pointer', opacity: isClicked ? '0.5' : '1' }}
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName, 2)
                                        }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.2.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}
                            </>
                        )}
                        {topScreenNum === 3 && (
                            <>
                                <BtnDiv>
                                    <Btn
                                        style={{ marginBottom: '27px' }}
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName, 1)
                                        }}
                                    >
                                        <BtnText>{t(`cards.dcards.3.button1`)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 1000 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 1000 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 1000 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName, 2)
                                    }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.3.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}
                            </>
                        )}
                        {topScreenNum === 4 && (
                            <>
                                <BtnDiv>
                                    <Btn
                                        style={{ marginBottom: '27px' }}
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName, 1)
                                        }}
                                    >
                                        <BtnText>{t(`cards.dcards.4.button1`)}</BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 2000 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 2000 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 2000 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        performCard(topScreenNum, taskName, 2)
                                    }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.4.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}

                            </>
                        )}
                        {topScreenNum === 5 && (
                            <>
                                <BtnDiv>
                                    <Btn
                                        onClick={debounce((ev) => {
                                            ev.persist();
                                            setIsClicked(true);
                                            setDelayButtonOption(prevDelayButtonOption => prevDelayButtonOption - 1);
                                            if (delayButtonOption == 1) {
                                                performCard(topScreenNum, taskName, 1);
                                            }
                                        }, 50)}
                                    >
                                        {delayButtonOption > 0 && (
                                            <BtnText>{insertVariablesToTranslation(t(`cards.dcards.5.button1`))}</BtnText>
                                        )}
                                        {delayButtonOption <= 0 && (
                                            <BtnText>{t(`cards.dcards.5.button1`).replace("$C", 0)}</BtnText>
                                        )}
                                    </Btn>
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 500 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 500 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 500 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn
                                        disabled={isClicked}
                                        style={{ cursor: isClicked ? 'context-menu' : 'pointer', opacity: isClicked ? '0.5' : '1' }}
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName, 2)
                                        }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.5.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}

                            </>
                        )}
                        {topScreenNum === 6 && (
                            <>
                                <BtnDiv>
                                    <Btn
                                        onClick={debounce((ev) => {
                                            ev.persist();
                                            setIsClicked(true);
                                            setDelayButtonOption(prevDelayButtonOption => prevDelayButtonOption - 1);
                                            if (delayButtonOption == 1) {
                                                performCard(topScreenNum, taskName, 1);
                                            }
                                        }, 50)}
                                    >
                                        {delayButtonOption > 0 && (
                                            <BtnText>{insertVariablesToTranslation(t(`cards.dcards.6.button1`))}</BtnText>
                                        )}
                                        {delayButtonOption <= 0 && (
                                            <BtnText>{t(`cards.dcards.6.button1`).replace("$C", 0)}</BtnText>
                                        )}
                                    </Btn>
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 1000 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 1000 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 1000 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn
                                        style={{ cursor: isClicked ? 'context-menu' : 'pointer', opacity: isClicked ? '0.5' : '1' }}
                                        onClick={(e) => {
                                            performCard(topScreenNum, taskName, 2)
                                            e.persist();
                                        }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.6.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}

                            </>
                        )}
                        {topScreenNum === 7 && (
                            <>
                                <BtnDiv>
                                    {cardsLiveView.filter(e => e.completed || e.redo).length > 0 ? <Btn
                                        onClick={debounce((ev) => {
                                            const _cards = JSON.parse(JSON.stringify(cardsLiveView)).sort((firstElement, secondElement) => {
                                                if (firstElement.completed && secondElement.completed) {
                                                    return 0
                                                }

                                                if (firstElement.completed) {
                                                    return -1
                                                }

                                                if (secondElement.completed) {
                                                    return 1
                                                }
                                            })
                                            let changedIndexCard = {};
                                            for (let i = _cards.length - 1; i >= 0; i--) {
                                                if (cardsLiveView[i].completed) {
                                                    changedIndexCard = cardsLiveView[i]
                                                    break;
                                                }
                                            }
                                            cardsLiveView.forEach(el => {  // to keep the changes to a minimum
                                                if (el.id === changedIndexCard.id) {
                                                    el.redo = true;
                                                    el.completed = false;
                                                }
                                            })
                                            tasksButOrTasksNotSaved = JSON.parse(JSON.stringify(tasksButOrTasksNotSaved)).sort((firstElement, secondElement) => {
                                                if (firstElement.completed && secondElement.completed) {
                                                    return 0
                                                }

                                                if (firstElement.completed) {
                                                    return -1
                                                }

                                                if (secondElement.completed) {
                                                    return 1
                                                }
                                            })
                                            tasksButOrTasksNotSaved.forEach(el => {  // to keep the changes to a minimum
                                                if (el.id === changedIndexCard.id) {
                                                    el.redo = true;
                                                    el.completed = false;
                                                }
                                            })
                                            setCardsLiveView(cardsLiveView)
                                            setTasksButOrTasksNotSaved(tasksButOrTasksNotSaved)
                                            axios.post(`${fetchConfig.prefix}/game/redo_last_task`, { gameId, userId, taskIdNumberInDB: changedIndexCard.taskIdnumberInDB })  // register the comment in the log
                                            // toggleProject(openStage);
                                            setIsClicked(true);
                                            performCard(topScreenNum, taskName, 1)
                                        }, 50)}
                                    >
                                        <BtnText>
                                            {t(`cards.dcards.7.button1`)}
                                        </BtnText>

                                    </Btn> : <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>
                                            {t(`cards.dcards.7.button1`)}
                                        </BtnText>
                                    </Btn>
                                    }
                                </BtnDiv>
                                {/* {playerStatus.earnedValue < 1000 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 1000 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 1000 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn
                                        style={{ cursor: isClicked ? 'context-menu' : 'pointer', opacity: isClicked ? '0.5' : '1' }}
                                        onClick={(e) => {
                                            e.persist();
                                            setIsClicked(true);
                                            performCard(topScreenNum, taskName, 2)

                                        }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.7.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}

                            </>
                        )}
                        {topScreenNum === 10 && (
                            <>
                                {!oneLessStep ? <BtnDiv>
                                    <Btn
                                        onClick={(e) => {
                                            e.persist();
                                            setOneLessStep(true);
                                            setIsClicked(true);
                                            performCard(topScreenNum, taskName, 1)
                                        }}
                                    >
                                        <BtnText>
                                            {t(`cards.dcards.10.button1`)}

                                        </BtnText>
                                    </Btn>
                                </BtnDiv> : <BtnDiv>
                                    <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                        <BtnText>
                                            {t(`cards.dcards.10.button1`)}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                }
                                {/* {playerStatus.earnedValue < 1000 && (
                                    <BtnDiv>
                                        <Btn style={{ opacity: '0.5', cursor: 'context-menu' }}>
                                            <BtnText>
                                                Deduct 1000 <BigDiamond /> from Value
                                            </BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                                {playerStatus.earnedValue >= 1000 && ( */}
                                <Or>{t('cards.dcards.or')}</Or>
                                <BtnDiv>
                                    <Btn
                                        style={{ cursor: isClicked ? 'context-menu' : 'pointer', opacity: isClicked ? '0.5' : '1' }}
                                        onClick={(e) => {
                                            e.persist();
                                            setIsClicked(true);
                                            performCard(topScreenNum, taskName, 2)
                                        }}>
                                        <BtnText>
                                            {insertVariablesToDelayTranslation(t(`cards.dcards.10.button2`))}
                                        </BtnText>
                                    </Btn>
                                </BtnDiv>
                                {/* )} */}

                            </>
                        )}
                    </BtnCon>
                </CenterAll>
            </InnerContainer>
        );
    }
    if (taskName == 'unplanned-task') {
        return (
            <>
                <InnerContainer style={{ zIndex: stage == 0 ? '27' : '26' }} taskName={taskName}>
                    <CenterAll>
                        <HeaderContainer>
                            <TaskContainer>
                                {taskName != t(`global_variables.actions.unplanned_task`) ? t(`global_variables.actions.unplanned_task`) : t('global_variables.task')}
                            </TaskContainer>
                            <TopScreenNumContainer>
                                <TopScreenBorder>
                                    <TopScreenNumber>{topScreenNum}</TopScreenNumber>
                                </TopScreenBorder>
                            </TopScreenNumContainer>
                        </HeaderContainer>
                        <ParagraphContainer>
                            <Paragraph>
                                {t(`cards.card.${topScreenNum}.card_title`, { topScreenNum })}
                            </Paragraph>
                            {cardEffect != '' && (
                                <Paragraph>{cardEffect}</Paragraph>
                            )}
                        </ParagraphContainer>
                        <PriceNScoreContainer>
                            <SecondLineContainer>
                                <LeftCon>
                                    {price > 0 && <SNPText>{t('global_variables.get_budget_link')}</SNPText>}
                                    {price <= 0 && <SNPText>{t('global_variables.cost')}</SNPText>}

                                    <SNPNumber> ${Math.abs(price)}</SNPNumber>
                                </LeftCon>
                                <RightCon>
                                    {(whiteNum > 0 || redNum > 0 || greenNum > 0) && (
                                        <SNPText>{t('global_variables.get_resources_link')}</SNPText>
                                    )}
                                    {(whiteNum <= 0 && redNum <= 0 && greenNum <= 0) && (
                                        <SNPText>{t('global_variables.resources.resources')}</SNPText>
                                    )}
                                    <SNPNumber>
                                        <BoxContainer>
                                            <WhiteSource />
                                            <NumNextImg>{Math.abs(whiteNum)}</NumNextImg>
                                        </BoxContainer>
                                        <BoxContainer>
                                            <RedSource />
                                            <NumNextImg>{Math.abs(redNum)}</NumNextImg>
                                        </BoxContainer>
                                        <BoxContainer>
                                            <GreenSource />
                                            <NumNextImg>{Math.abs(greenNum)}</NumNextImg>
                                        </BoxContainer>
                                    </SNPNumber>
                                </RightCon>
                            </SecondLineContainer>
                            <SecondLineContainer>
                                <LeftConEarnedValue>
                                    <SNPText>{t('global_variables.value')}</SNPText>
                                    <EarnedValueContainer>
                                        <SNPNumber> {Math.abs(earnedValue)}</SNPNumber>
                                        <WhiteDiamondContainer>
                                            <WhiteDiamond />
                                        </WhiteDiamondContainer>
                                    </EarnedValueContainer>
                                </LeftConEarnedValue>
                                <LeftCon>
                                    {steps > 0 &&
                                        Math.abs(steps) !== 100 &&
                                        Math.abs(steps) !== 1000 && (
                                            <>
                                                <SNPText>{t('global_variables.steps')}</SNPText>
                                                {(oneLessStep && Math.abs(steps) > 0) ?
                                                    <SNPNumber>
                                                        <div style={{ textDecoration: (oneLessStep && steps > 0) ? 'line-through' : '' }}>
                                                            {Math.abs(steps)}
                                                        </div>
                                                        <div style={{ display: (oneLessStep && steps > 0) ? 'block' : 'none', marginLeft: '4px' }}>
                                                            {Math.abs(steps) - 1}
                                                        </div>
                                                    </SNPNumber>
                                                    : <SNPNumber>
                                                        {Math.abs(steps)}
                                                    </SNPNumber>
                                                }
                                            </>
                                        )}
                                    {steps <= 0 && (
                                        <>
                                            <SNPText>{t('global_variables.steps')}</SNPText>
                                            <SNPNumber>{Math.trunc(steps)}</SNPNumber>
                                        </>
                                    )}
                                </LeftCon>
                            </SecondLineContainer>
                            {!canExecuteTasks() &&
                                (price < 0 || whiteNum < 0 || redNum < 0 || greenNum < 0) && (
                                    <ErrorContainer>
                                        <ErrorHeadLine>
                                            {t('cards.card.not_enough_resources')}
                                        </ErrorHeadLine>
                                        <OptionContainer
                                            style={{ cursor: 'pointer', width: 'max-content' }}
                                            onClick={(e) => {
                                                e.persist();
                                                toggleResources('Buy resources')
                                            }}
                                        >
                                            {t('global_variables.get_resources_link')}
                                        </OptionContainer>
                                        <OptionContainer
                                            style={{ cursor: 'pointer', width: 'max-content' }}
                                            onClick={(e) => {
                                                e.persist();
                                                additionalBudgetGlobalFunction(
                                                    'modals.additional_budget.info_title',
                                                    'modals.additional_budget.info_text',
                                                    'modals.additional_budget.button1',
                                                    'modals.additional_budget.button1'
                                                )
                                            }}
                                        >
                                            {t('global_variables.additional_budget_link')}
                                        </OptionContainer>
                                    </ErrorContainer>
                                )
                            }
                        </PriceNScoreContainer>

                        <BtnCon>
                            {canExecuteTasks() && !chekWrongConstrains() && (
                                <BtnDiv>
                                    <Btn
                                        onClick={(e) => {
                                            e.persist();
                                            performCard(topScreenNum, taskName, null, commentTrapTaskPerformed); removeUnplannedCards(card.id);
                                        }}
                                    >
                                        <BtnText>{t('cards.card.unplanned_button1')}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {!canExecuteTasks() &&
                                !chekWrongConstrains() &&
                                (price < 0 || whiteNum < 0 || redNum < 0 || greenNum < 0) && (
                                    <BtnDiv
                                    >
                                        <Btn
                                            style={{
                                                opacity: '0.5',
                                                cursor: 'context-menu',
                                            }}
                                        >
                                            <BtnText>{t('cards.card.unplanned_button1')}</BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                            {chekTakeDelayCardStatus() && (
                                <BtnDiv>
                                    <Btn onClick={(e) => {
                                        e.persist();
                                        SoundPlay(soundForFlipAndCards);
                                        handleCard('Delay');
                                        explanationCard ? addBackCard() : '';
                                        setDelayFromUnplannedTask(true);
                                        setIsChoosingFromDelayedCard(true)
                                    }}>
                                        <BtnText>{t('cards.card.unplanned_button2')}</BtnText>
                                    </Btn>
                                </BtnDiv>
                            )}
                            {taskName == 'unplanned-task' &&
                                !chekTakeDelayCardStatus() &&
                                !noSeconButtonNeed() && (
                                    <BtnDiv>
                                        <Btn onClick={(e) => {
                                            e.persist();
                                            handleCard('unplanned-task');
                                        }}>
                                            <BtnText>{t('cards.card.unable_execute_task')}</BtnText>
                                        </Btn>
                                    </BtnDiv>
                                )}
                        </BtnCon>
                    </CenterAll>
                </InnerContainer>
                <InnerContainer taskName={taskName} style={{ zIndex: '26', display: explanationCard ? '' : 'none' }}>
                    <Carousel activeIndex={carouselIndex} onSelect={handleCarouselMovement} interval={null} style={{ width: '100%', overflow: 'visible', position: 'unset' }}>
                        {explanationCard && !reachedMaximumAmountOfUnplannedTasks && (
                            <Carousel.Item>
                                <InnerContainer style={{ position: 'fixed' }} >
                                    <CenterAll>
                                        <HeaderContainer>
                                            <TaskContainer>
                                                {t('cards.delayed_unplanned_card.delayed_unplanned_title')}
                                            </TaskContainer>
                                        </HeaderContainer>
                                        <ParagraphContainer style={{ height: '75%' }}>
                                            <Paragraph>{t('cards.delayed_unplanned_card.info_text')}</Paragraph>
                                        </ParagraphContainer>
                                        <BtnDiv style={{ height: '56px' }}>
                                            <Btn onClick={(e) => {
                                                e.persist();
                                                setStage(0);
                                                setIsChoosingFromDelayedCard(false)
                                                setCardState(true);
                                                setSelectedCardIs(0);
                                            }}>
                                                <BtnText>{t('cards.delayed_unplanned_card.button1')}</BtnText>
                                            </Btn>
                                        </BtnDiv>
                                    </CenterAll>
                                </InnerContainer>
                            </Carousel.Item>
                        )}
                        {unplannedCards.map((current, arrayIndex) => {
                            const canExecuteTasksCarousel = () => {
                                if (
                                    playerStatus.budget >= Math.abs(current.costMoney) &&
                                    (current.costResourcesNormal > 0 || playerStatus.resources.regular >= Math.abs(current.costResourcesNormal)) &&
                                    (current.costResourcesSenior > 0 || playerStatus.resources.executive >= Math.abs(current.costResourcesSenior)) &&
                                    (current.costResourcesExpensive > 0 || playerStatus.resources.expensive >= Math.abs(current.costResourcesExpensive))
                                ) {
                                    return true
                                }
                            }
                            return (
                                <Carousel.Item key={arrayIndex}>
                                    <InnerContainer style={{ position: 'fixed' }}>
                                        <CenterAll>
                                            <HeaderContainer>
                                                <TaskContainer>
                                                    {taskName != t(`global_variables.actions.unplanned_task`) ? t(`global_variables.actions.unplanned_task`) : t('global_variables.task')}
                                                </TaskContainer>
                                                <TopScreenNumContainer>
                                                    <TopScreenBorder>
                                                        <TopScreenNumber>{current.id}</TopScreenNumber>
                                                    </TopScreenBorder>
                                                </TopScreenNumContainer>
                                            </HeaderContainer>
                                            <ParagraphContainer>
                                                <Paragraph>
                                                    {t(`cards.card.${current.id}.card_title`, { id: current.id })}
                                                </Paragraph>
                                                {cardEffect != '' && (
                                                    <Paragraph>
                                                        {insertVariablesToTranslation(t(`cards.card.${current.id}.info_text`, { id: current.id }))}
                                                    </Paragraph>
                                                )}
                                            </ParagraphContainer>
                                            <PriceNScoreContainer>
                                                <SecondLineContainer>
                                                    <LeftCon>
                                                        {current.costMoney > 0 && <SNPText>{t('global_variables.get_budget_link')}</SNPText>}
                                                        {current.costMoney <= 0 && <SNPText>{t('global_variables.cost')}</SNPText>}

                                                        <SNPNumber> ${Math.abs(current.costMoney)}</SNPNumber>
                                                    </LeftCon>
                                                    <RightCon>
                                                        {(current.costResourcesNormal > 0 || current.costResourcesSenior > 0 || current.costResourcesExpensive > 0) && (
                                                            <SNPText>{t('global_variables.get_resources_link')}</SNPText>
                                                        )}
                                                        {(current.costResourcesNormal <= 0 || current.costResourcesSenior <= 0 || current.costResourcesExpensive <= 0) && (
                                                            <SNPText>{t('global_variables.resources.resources')}</SNPText>
                                                        )}
                                                        <SNPNumber>
                                                            <BoxContainer>
                                                                <WhiteSource />
                                                                <NumNextImg>{Math.abs(current.costResourcesNormal)}</NumNextImg>
                                                            </BoxContainer>
                                                            <BoxContainer>
                                                                <RedSource />
                                                                <NumNextImg>{Math.abs(current.costResourcesSenior)}</NumNextImg>
                                                            </BoxContainer>
                                                            <BoxContainer>
                                                                <GreenSource />
                                                                <NumNextImg>{Math.abs(current.costResourcesExpensive)}</NumNextImg>
                                                            </BoxContainer>
                                                        </SNPNumber>
                                                    </RightCon>
                                                </SecondLineContainer>
                                                <SecondLineContainer>
                                                    <LeftConEarnedValue>
                                                        <SNPText>{t('global_variables.value')}</SNPText>
                                                        <EarnedValueContainer>
                                                            <SNPNumber> {Math.abs(current.earnedValue)}</SNPNumber>
                                                            <WhiteDiamondContainer>
                                                                <WhiteDiamond />
                                                            </WhiteDiamondContainer>
                                                        </EarnedValueContainer>
                                                    </LeftConEarnedValue>
                                                    <LeftCon>
                                                        <SNPText>{t('global_variables.steps')}</SNPText>
                                                        {Math.abs(current.steps) === 100 || Math.abs(current.steps) === 1000
                                                            ? 'Return'
                                                            : (oneLessStep && Math.abs(current.steps) > 0) ?
                                                                <SNPNumber>
                                                                    <div style={{ textDecoration: (oneLessStep && current.steps > 0) ? 'line-through' : '' }}>
                                                                        {Math.abs(current.steps)}
                                                                    </div>
                                                                    <div style={{ display: (oneLessStep && current.steps > 0) ? 'block' : 'none', marginLeft: '4px' }}>
                                                                        {Math.abs(current.steps) - 1}
                                                                    </div>
                                                                </SNPNumber>
                                                                : <SNPNumber>
                                                                    {Math.abs(current.steps)}
                                                                </SNPNumber>
                                                        }
                                                    </LeftCon>
                                                </SecondLineContainer>
                                                {!canExecuteTasksCarousel() &&
                                                    (current.price < 0 || current.costResourcesNormal < 0 || current.costResourcesSenior < 0 || current.costResourcesExpensive < 0) && (
                                                        <ErrorContainer>
                                                            <ErrorHeadLine>
                                                                {t('cards.card.not_enough_resources')}
                                                            </ErrorHeadLine>
                                                            <OptionContainer
                                                                style={{ cursor: 'pointer', width: 'max-content' }}
                                                                onClick={(e) => {
                                                                    e.persist();
                                                                    toggleResources('Buy resources')
                                                                }}
                                                            >
                                                                {t('global_variables.get_resources_link')}
                                                            </OptionContainer>
                                                            <OptionContainer
                                                                style={{ cursor: 'pointer', width: 'max-content' }}
                                                                onClick={(e) => {
                                                                    e.persist();
                                                                    additionalBudgetGlobalFunction(
                                                                        'modals.additional_budget.info_title',
                                                                        'modals.additional_budget.info_text',
                                                                        'modals.additional_budget.button1',
                                                                        'modals.additional_budget.button1'
                                                                    )
                                                                }}
                                                            >
                                                                {t('global_variables.additional_budget_link')}
                                                            </OptionContainer>
                                                        </ErrorContainer>
                                                    )}
                                            </PriceNScoreContainer>

                                            <BtnCon>
                                                {explanationCard && (
                                                    <BtnDiv>
                                                        <Btn
                                                            style={{
                                                                opacity: canExecuteTasksCarousel() ? '1' : '0.5',
                                                                cursor: canExecuteTasksCarousel() ? 'pointer' : 'context-menu'
                                                            }}
                                                            disabled={!canExecuteTasksCarousel()}
                                                            onClick={(e) => {
                                                                e.persist();
                                                                performCard(current.id, current.type, null, commentDelayFromUnplannedTask, [commentTrapTaskPerformed]);
                                                                removeUnplannedCards(current.id);
                                                            }}>
                                                            <BtnText>{t('project_sheet.execute')}</BtnText>
                                                        </Btn>
                                                    </BtnDiv>
                                                )}
                                                {!explanationCard && (
                                                    <BtnDiv>
                                                        <Btn
                                                            style={{
                                                                opacity: canExecuteTasks() ? '1' : '0.5',
                                                                cursor: canExecuteTasks() ? 'pointer' : 'context-menu'
                                                            }}
                                                            disabled={!canExecuteTasks()}
                                                            onClick={(e) => {
                                                                e.persist();
                                                                performCard(current.id, current.type);
                                                                removeUnplannedCards(current.id);
                                                            }}>
                                                            <BtnText>{t('project_sheet.execute')}</BtnText>
                                                        </Btn>
                                                    </BtnDiv>
                                                )}
                                                {!explanationCard && (
                                                    <BtnDiv>
                                                        <Btn
                                                            onClick={(e) => {
                                                                e.persist();
                                                                handleCard('Delay');
                                                                SoundPlay(soundForFlipAndCards);
                                                                setIsChoosingFromDelayedCard(true)
                                                            }}
                                                        >
                                                            <BtnText>{t('modals.gate_options_delay_button1')}</BtnText>
                                                        </Btn>
                                                    </BtnDiv>
                                                )}

                                            </BtnCon>
                                        </CenterAll>
                                    </InnerContainer>
                                </Carousel.Item>
                            );
                        })}
                    </Carousel>
                </InnerContainer>
            </>
        );
    }
}
export default React.memo(TaskPopUp);
